export default __webpack_public_path__ + "static/media/O-034.483ac742.png";